import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaPhone, FaEnvelope, FaGlobe,
  FaInstagram, FaLinkedin, FaWhatsapp,
  FaArrowRight
} from 'react-icons/fa';

const ScrollToTopLink = ({ to, children, ...props }) => (
  <NavLink to={to} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} {...props}>
    {children}
  </NavLink>
);

const Footer = () => {
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.elements.email.value;
    if (!email) return setStatus('empty');

    const formData = new FormData(e.target);
    try {
      const res = await fetch('https://formspree.io/f/xanjlgbw', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      if (res.ok) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <>
      <footer className="footer">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>

        <div className="container">
          <div className="footer-grid">

            {/* Column 1: Brand + Contact */}
            <div className="footer-col footer-brand-col">
              <ScrollToTopLink to="/">
                <img src="/Images/logo-white.png" className="footer-logo" alt="Octalbees Logo" />
              </ScrollToTopLink>
              <p className="footer-tagline">Building real products. Training real talent.</p>
              <ul className="footer-contact-list">
                <li>
                  <FaPhone className="footer-contact-icon" />
                  <a href="tel:+919470506529">+91-9470506529</a>
                </li>
                <li>
                  <FaEnvelope className="footer-contact-icon" />
                  <a href="mailto:info@octalbees.com">info@octalbees.com</a>
                </li>
                <li>
                  <FaGlobe className="footer-contact-icon" />
                  <a href="https://octalbees.com/" target="_blank" rel="noopener noreferrer">
                    www.octalbees.com
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 2: Company */}
            <div className="footer-col">
              <h3 className="footer-heading">Company</h3>
              <ul className="footer-ul">
                <li><ScrollToTopLink to="/">Home</ScrollToTopLink></li>
                <li><ScrollToTopLink to="/about-us">About Us</ScrollToTopLink></li>
                <li><ScrollToTopLink to="/services">Services</ScrollToTopLink></li>
                <li><ScrollToTopLink to="/internship">Internship Program</ScrollToTopLink></li>
                {/* <li><ScrollToTopLink to="/programs/ai-powered-full-stack-developer">AI Full-Stack Program</ScrollToTopLink></li> */} {/* TEMPORARILY HIDDEN */}
                <li><ScrollToTopLink to="/ambassador">Ambassador Program</ScrollToTopLink></li>
                <li><ScrollToTopLink to="/verify">Verify Certificate</ScrollToTopLink></li>
                <li><ScrollToTopLink to="/careers">Careers</ScrollToTopLink></li>
                <li><ScrollToTopLink to="/contact-us">Contact Us</ScrollToTopLink></li>
              </ul>
            </div>

            {/* Column 3: Legal */}
            <div className="footer-col">
              <h3 className="footer-heading">Legal</h3>
              <ul className="footer-ul">
                <li><ScrollToTopLink to="/privacy-policy">Privacy Policy</ScrollToTopLink></li>
                <li><ScrollToTopLink to="/terms-and-conditions">Terms &amp; Conditions</ScrollToTopLink></li>
                <li><ScrollToTopLink to="/cancellation-and-refund-policy">Refund Policy</ScrollToTopLink></li>
                <li><ScrollToTopLink to="/shipping-policy">Shipping Policy</ScrollToTopLink></li>
              </ul>
            </div>

            {/* Column 4: Social + Newsletter */}
            <div className="footer-col">
              <h3 className="footer-heading">Stay Connected</h3>
              <div className="footer-social-icons">
                <a href="https://instagram.com/octalbees_" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://www.linkedin.com/company/octalbees" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="LinkedIn">
                  <FaLinkedin />
                </a>
                <a href="https://wa.me/919470506529" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="WhatsApp">
                  <FaWhatsapp />
                </a>
              </div>

              <div className="newsletter-box">
                <p>Get updates on internships, services, and offers.</p>
                <form className="newsletter-form" onSubmit={handleSubmit}>
                  <input type="email" name="email" placeholder="Your email address" required />
                  <button type="submit">
                    Subscribe <FaArrowRight style={{ marginLeft: '6px', fontSize: '0.8rem' }} />
                  </button>
                </form>
                {status === 'success' && <div className="form-msg success">✅ You're subscribed!</div>}
                {status === 'error' && <div className="form-msg error">❌ Something went wrong. Try again.</div>}
                {status === 'empty' && <div className="form-msg error">⚠️ Please enter your email.</div>}
              </div>
            </div>

          </div>
        </div>
      </footer>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p className="copyright-text">© 2026 Octalbees. All Rights Reserved.</p>
          <div className="footer-bottom-links">
            <ScrollToTopLink to="/privacy-policy">Privacy</ScrollToTopLink>
            <ScrollToTopLink to="/terms-and-conditions">Terms</ScrollToTopLink>
            <ScrollToTopLink to="/cancellation-and-refund-policy">Refund</ScrollToTopLink>
          </div>
        </div>
      </div>

      <style>{`
        /* =============================================
           FOOTER — Clean 4-Column Layout
           ============================================= */

        .footer {
          background-color: #0c001f;
          color: #e0e0e0;
          padding: 50px 0 30px 0;
          position: relative;
          overflow: hidden;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 1.4fr 1fr 1fr 1.4fr;
          gap: 30px;
        }

        /* --- Brand Column --- */
        .footer-tagline {
          font-size: 0.9rem;
          color: #9a9aaa;
          margin: 0 0 20px 0;
          line-height: 1.6;
        }

        .footer-logo {
          max-width: 150px;
          height: auto;
          margin-bottom: 14px;
          display: block;
        }

        .footer-contact-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .footer-contact-list li {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .footer-contact-icon {
          color: #a04ff4;
          font-size: 0.95rem;
          flex-shrink: 0;
        }

        .footer-contact-list a {
          color: #c0c0c0;
          text-decoration: none;
          font-size: 0.92rem;
          transition: color 0.25s ease;
        }

        .footer-contact-list a:hover {
          color: #ffb428;
        }

        /* --- Headings --- */
        .footer-heading {
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #a04ff4;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid rgba(160, 79, 244, 0.25);
        }

        /* --- Nav Link Columns --- */
        .footer-ul {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .footer-ul li a {
          color: #b0b0c0;
          text-decoration: none;
          font-size: 0.93rem;
          transition: color 0.25s ease, padding-left 0.25s ease;
          display: inline-block;
        }

        .footer-ul li a:hover {
          color: #ffffff;
          padding-left: 4px;
        }

        /* --- Social Icons --- */
        .footer-social-icons {
          display: flex;
          gap: 10px;
          margin-bottom: 24px;
        }

        .footer-social-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 38px;
          height: 38px;
          border-radius: 8px;
          background: rgba(160, 79, 244, 0.12);
          border: 1px solid rgba(160, 79, 244, 0.25);
          color: #c0c0d0;
          font-size: 1rem;
          text-decoration: none;
          transition: all 0.25s ease;
        }

        .footer-social-btn:hover {
          background: rgba(160, 79, 244, 0.3);
          border-color: #a04ff4;
          color: #ffffff;
          transform: translateY(-2px);
        }

        /* --- Newsletter Box --- */
        .newsletter-box {
          background: rgba(26, 15, 45, 0.7);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 12px;
          padding: 20px;
          backdrop-filter: blur(8px);
        }

        .newsletter-box p {
          font-size: 0.88rem;
          color: #9a9aaa;
          margin-bottom: 14px;
          line-height: 1.5;
        }

        .newsletter-form {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .newsletter-form input {
          width: 100%;
          padding: 10px 14px;
          font-size: 0.9rem;
          border: 1px solid transparent;
          border-radius: 8px;
          background: rgba(0, 0, 0, 0.25);
          color: #fff;
          outline: none;
          transition: all 0.3s ease;
          box-sizing: border-box;
        }

        .newsletter-form input::placeholder {
          color: #555;
        }

        .newsletter-form input:focus {
          border-color: #a04ff4;
          box-shadow: 0 0 0 2px rgba(160, 79, 244, 0.25);
        }

        .newsletter-form button {
          padding: 10px 16px;
          font-size: 0.9rem;
          border: none;
          border-radius: 8px;
          background: linear-gradient(90deg, #a04ff4, #7c22d4);
          color: #fff;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .newsletter-form button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(160, 79, 244, 0.35);
        }

        .form-msg {
          margin-top: 10px;
          padding: 8px 12px;
          border-radius: 6px;
          font-size: 0.85rem;
          font-weight: 500;
          text-align: center;
          animation: form-msg-fade-in 0.4s ease;
        }
        .form-msg.success { background: rgba(22, 163, 74, 0.15); color: #4ade80; }
        .form-msg.error   { background: rgba(239, 68, 68, 0.15); color: #f87171; }

        @keyframes form-msg-fade-in {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* --- Footer Bottom Bar --- */
        .footer-bottom {
          background-color: #080014;
          color: #666;
          padding: 14px 0;
          border-top: 1px solid rgba(255, 255, 255, 0.07);
          font-size: 0.85rem;
        }

        .footer-bottom-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .copyright-text {
          margin: 0;
          color: #666;
        }

        .footer-bottom-links {
          display: flex;
          gap: 20px;
        }

        .footer-bottom-links a {
          color: #666;
          text-decoration: none;
          transition: color 0.2s;
        }

        .footer-bottom-links a:hover {
          color: #a04ff4;
        }

        /* --- Animated Background Shapes --- */
        .shape {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          opacity: 0.4;
          z-index: 0;
          pointer-events: none;
          animation: float-animation 25s infinite alternate ease-in-out;
        }

        .shape-1 {
          width: 400px;
          height: 400px;
          background: #a04ff4;
          bottom: -150px;
          left: -100px;
          animation-duration: 30s;
        }

        .shape-2 {
          width: 350px;
          height: 350px;
          background: #ffb428;
          top: -100px;
          right: -120px;
          animation-duration: 25s;
          animation-delay: 3s;
        }

        @keyframes float-animation {
          from { transform: translateY(0px) translateX(0px) rotate(0deg); }
          to   { transform: translateY(30px) translateX(-40px) rotate(180deg); }
        }

        /* --- Responsive --- */
        @media (max-width: 1199px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 40px;
          }
        }

        @media (max-width: 767px) {
          .footer {
            padding: 40px 20px 20px;
          }
          .footer-grid {
            grid-template-columns: 1fr;
            gap: 24px;
          }
          .footer-bottom-inner {
            flex-direction: column;
            gap: 10px;
            text-align: center;
          }
          .footer-social-icons {
            justify-content: flex-start;
          }
        }
      `}</style>
    </>
  );
};

export default Footer;